import {isMobile} from 'Utils/deviceUtils';

export default class FormulaItemsController {
    constructor(domElement) {
        if(!domElement) {
            throw new DOMException('element is undefined');
        }

        const isInitialized = domElement.dataset.formulaItemsInitialized === 'true';

        if(isInitialized === true) {
            return;
        }

        domElement.FormulaItemsCtl = this;
        domElement.dataset.formulaItemsInitialized = 'true';

        this.domElement = domElement;
        this._domAllSummaryTitlesList = [...this.domElement.querySelectorAll('.summary .title')];

        this.registerEvents();
    }

    registerEvents() {
        const method = isMobile() ? 'touchstart' : 'click';

        this._domAllSummaryTitlesList.forEach(summaryTitle => {
            summaryTitle.addEventListener(method, this.handleSummaryTitleClick.bind(this));
        }, this);
    }

    handleSummaryTitleClick(event) {
        event.preventDefault();

        let maxSummaryDetailsHeight = 0;

        this._domAllSummaryTitlesList.forEach(summaryTitle => {
            const summaryTitleToggle = summaryTitle.parentNode.querySelector('.toggle');

            if(summaryTitleToggle.checked === false) {
                summaryTitleToggle.checked = true;

                const summaryDetailsHeight = this.getSummaryDetailsHeight(summaryTitle.parentNode.querySelector('.details'));

                if(summaryDetailsHeight > maxSummaryDetailsHeight) {
                    maxSummaryDetailsHeight = summaryDetailsHeight;
                }
            } else {
                summaryTitleToggle.checked = false;
            }
        }, this);

        this.setAllSummaryDetailsHeightToMax(maxSummaryDetailsHeight);
    }

    getSummaryDetailsHeight(domSummaryDetails) {
        let summaryDetailsHeight = 0;

        [...domSummaryDetails.querySelectorAll('ul, div')].forEach(domSummaryDetailsElement => {
            summaryDetailsHeight += parseInt(window.getComputedStyle(domSummaryDetailsElement).getPropertyValue('height'), 10)
                + parseInt(window.getComputedStyle(domSummaryDetailsElement).marginTop, 10)
                + parseInt(window.getComputedStyle(domSummaryDetailsElement).marginBottom, 10);
        }, this);

        return summaryDetailsHeight;
    }

    setAllSummaryDetailsHeightToMax(maxSummaryDetailsHeight) {
        [...this.domElement.querySelectorAll('.summary .details')].forEach(domSummaryDetails => {
            domSummaryDetails.style.height = `${maxSummaryDetailsHeight}px`;
        }, this);
    }
}

